// Angular
import { Component } from '@angular/core';
import { ajaxservice } from '../../../../services/ajaxservice'; // Common API service for both get and post
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router'; // To enable routing for this component
import { ToastrService } from 'ngx-toastr';// To use toastr
import Swal from 'sweetalert2';

@Component({
	selector: 'kt-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
	email: any;
	constructor(public ajax: ajaxservice, private router: Router, private toastr: ToastrService, private activatedRoute: ActivatedRoute) {

	}
	currentRouter = this.router.url;
	myFunction() {
		document.getElementById("myDropdown")?.classList.toggle("show");
	}

	// logout() {
	// 	 this.router.navigate(['/login']);   
	// }  
	logout() {
		//console.log(localStorage.getItem('pro_employee_code'));

		this.email = localStorage.getItem('pro_email');
		var empid =this.email;
		var url = 'customer_logout/?';             // api url for getting the details with using post params
		var id = "email";                      //id for using identify the amc name
		Swal.fire({
			title: 'Are you sure?',
			text: "Do you want to logout!",
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Yes',
			allowOutsideClick: false,                          //sweet alert will not close on oustside click
		}).then((result) => {
			Router
			if (result.value) {
				this.ajax.getdataparam(url, id, empid).subscribe((result) => { //console.log(result); return;
					if (result.response.response_code == "200") {

						localStorage.removeItem("pro_user_role");
						localStorage.removeItem("pro_employee_code");
						localStorage.removeItem("pro_employee_id");
						localStorage.removeItem("pro_email");
						localStorage.removeItem("pro_asideMenus");
						localStorage.removeItem("pro_user_status");
						localStorage.removeItem("pro_role_id");
						localStorage.removeItem("pro_organization_type");
						localStorage.removeItem("pro_ticket_id");
						localStorage.removeItem("pro_layoutConfig");
						localStorage.removeItem("pro_user_name");
						localStorage.removeItem("pro_language");					
					 
						//	localStorage.clear();
						// this.router.navigate(['login'])
						window.location.reload();
						// this.toastr.success(result.response.message, 'Success');        //toastr message for success
						//   this.router.navigateByUrl('/login');

					}
					else if (result.response.response_code == "400") {                //if failure
						this.toastr.error(result.response.message, 'Error');            //toastr message for error
					}
					else {                                                         //if not sucess
						this.toastr.error(result.response.message, 'Error');        //toastr message for error
					}
				}, (err) => {
					console.log(err);                                        //prints if it encounters an error
				});
			}
		})
	}



	// 		var url = 'fp_logout/';            
	// 		this.ajax.getdata(url).subscribe((result) => {
	// 		  if (result.response.response_code == "200") {                      

	// 		  }
	// 		  else if (result.response.response_code == "500"){                           
	// 			this.toastr.error(result.response.message, 'Error');       
	// 		  }
	//   else{                                                        
	// 	this.toastr.error(result.response.message, 'Error');        
	//   }
	// 		}, (err) => {                                          
	// 		  console.log(err);                                       
	// 		});

	// 	  }
}
